import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, intlShape} from 'react-intl';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import {actionPending} from 'utils/redux/thunkActionHelpers';
import {PURCHASES_FETCH} from './redux';
import Loading from 'components/loading/Loading';
import PurchaseCard from './PurchaseCard';
import styles from './purchases.scss';
import {MySunbitBanner} from "../components/banners/MySunbitBanner/mySunbitBanner";

@injectIntl
@CSSModules(styles, {allowMultiple: true})
class Purchases extends React.Component {
  static propTypes = {
    intl: intlShape,
    purchases: PropTypes.array,
    document: PropTypes.object,
    active: PropTypes.bool.isRequired,
    actionType: PropTypes.string.isRequired,
    actionStatus: PropTypes.string.isRequired,
    purchasesFetch: PropTypes.func.isRequired,
    purchasesFetchActive: PropTypes.func.isRequired,
    sunbitCardStatus: PropTypes.object,
    trackEvent: PropTypes.func,
    isModalOpen:PropTypes.bool.isRequired,
    link: PropTypes.string.isRequired,
    onExitModal: PropTypes.func.isRequired,
  };

  isPurchasesLoading() {
    return actionPending(PURCHASES_FETCH, this.props.actionType, this.props.actionStatus);
  }

  onExitModal() {
    this.props.onExitModal();
  }


  onBigApplyClicked() {
    this.props.trackEvent("New apply big modal clicked", {flow: 'purchases', flowType: 'card'});
    window.open(this.props.link, '_blank');
  }

  render() {
    const {purchases, active, purchasesFetch, purchasesFetchActive, intl:{formatMessage}} = this.props;
    const isLoading = this.isPurchasesLoading();
    return (
      <div styleName="purchases" data-at="page-purchases">
        <header styleName="header">
          <h1 styleName="heading">{formatMessage({id:'purchases.label.heading'})}</h1>
          <nav styleName="filters">
            <a data-at="show_active_purchases" styleName={classNames('filter', {isActive: active})} onClick={purchasesFetchActive}>{formatMessage({id:'purchases.nav.label.activePurchases'})}</a>
            <a data-at="show_all_purchases" styleName={classNames('filter', {isActive: !active})} onClick={purchasesFetch}>{formatMessage({id:'purchases.nav.label.allPurchases'})}</a>
          </nav>
        </header>
        <div styleName="purchaseList">
        {
          isLoading &&
          <div styleName="loadingPurchases">
            <Loading />
            Loading...
          </div>
        }
        {
          !isLoading && (
            (isLoading || !purchases || !purchases.length) ?
              <div styleName="empty">{formatMessage({id: (active ? 'purchases.empty.active.text' : 'purchases.empty.all.text')})}</div> :
              <div styleName="nonEmptyPurchaseList">{purchases.map((purchase) => (
                <PurchaseCard key={purchase.externalId} purchase={purchase}/>))}</div>
          )
        }
        </div>
          <MySunbitBanner isOpen={this.props.isModalOpen}
                          onExit={this.onExitModal.bind(this)}
                          name={'card-application'}
                          applyClicked={this.onBigApplyClicked.bind(this)}
                          smallHeader={formatMessage({id: "purchase.banner.limitedOffer"})}
                          header={formatMessage({id: "purchase.banner.getThe"})}
                          imgSrc={'/static/images/handing_card.png'}
                          note={formatMessage({id: "purchase.banner.issuedBy"})}
                          buttonText={formatMessage({id: "purchase.banner.applyNow"})}/>
      </div>
    );
  }
}

export default Purchases;



// WEBPACK FOOTER //
// ./src/purchases/Purchases.js